import React, { Fragment, useState, useEffect } from 'react';
import { InputBase } from '@material-ui/core';
import { Clear, Search as SearchIcon } from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  searchInputRoot: {
    width: '100%',
    fontSize: theme.textFontSize,
    borderBottom: `1px solid ${theme.iconColor}`,
  },
  searchInput: {
    padding: '5px 10px',
    fontSize: theme.textFontSize,
    border: 'none',
    color: theme.TextColor,
    height: 24,
    '&:focus': {
      border: 'none'
    },
    '&::placeholder': {
      color: theme.TextColor,
      opacity: '0.5'
    }
  },
  searchInputFocused: {
    borderColor: theme.HeaderSelectedText,
    borderWidth: 2
  },
  iconStyle: {
    fontSize: theme.headerTextFontSize16,
    color: theme.iconColor,
    cursor: 'pointer'
  }
});

const ListSearch = ({ classes, onSearch, placeholder = 'Search…', isClearable = true, value: externalValue }) => {
  const [searchTerm, setSearchTerm] = useState(externalValue || '');
  
  // Update internal state when external value changes
  useEffect(() => {
    if (externalValue !== undefined) {
      setSearchTerm(externalValue);
    }
  }, [externalValue]);

  const handleSearch = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    onSearch(value);
  };
  
  const handleClear = () => {
    setSearchTerm('');
    onSearch('');
  };

  const showClearIcon = isClearable && searchTerm;
  return (
    <InputBase
      placeholder={placeholder}
      classes={{
        root: classes.searchInputRoot,
        input: classes.searchInput,
        focused: classes.searchInputFocused
      }}
      value={searchTerm}
      onChange={handleSearch}
      endAdornment={
        <Fragment>
          {showClearIcon ? <Clear className={classes.iconStyle} onClick={handleClear} /> : ''}
          <SearchIcon className={classes.iconStyle} />
        </Fragment>
      }
    />
  );
};

export default withStyles(styles)(ListSearch);
